import { Mode } from "../enum/mode";

export class ConfigurationClient {
    cci_id: number = -1;
    cci_nom_societe: string = '';
    cci_affichage_initiale_utilisateur: boolean = false;
    cci_affichage_initiale_bureau: boolean = false;
    cci_longueur_initiale_utilisateur: number = -1;
    cci_longueur_initiale_bureau: number = -1;
    cci_affichage_ref_metier_lot: boolean = false;
    cci_photo_projection_position: string = '';
    cci_photo_projection_margin: number = -1;
    cci_photo_projection_opacity: number = -1;
    cci_photo_projection_width: number = -1;
    cci_photo_projection_height: number = -1;
    cci_photo_projection: boolean = false;
    cci_computed_name_lot: string = '';
    cci_modele_doc_word: boolean = false;
    cci_base_commune: boolean = false;
    cci_mode_a_17: Mode = Mode.PROMOTION;
    cci_afficher_info_general_junot: boolean = false;
    cci_afficher_localisation: boolean = false;
    cci_afficher_copropriete: boolean = false;
    cci_messagerie: boolean = false;
    cci_documents_requis: boolean = false;
    cci_statistiques: boolean = false;
    cci_style: string = '';
    cci_dvcc_condition_devis: string = null;
    cci_dvcc_condition_devis_en: string = null;
    cci_dvcc_condition_devis_de: string = null;
    cci_dvcc_condition_devis_nl: string = null;
    cci_dvcc_remarque_devis: string = null;
    cci_dvcc_remarque_devis_en: string = null;
    cci_dvcc_remarque_devis_de: string = null;
    cci_dvcc_remarque_devis_nl: string = null;
    cci_dvcc_condition_commande: string = null;
    cci_dvcc_condition_commande_en: string = null;
    cci_dvcc_condition_commande_de: string = null;
    cci_dvcc_condition_commande_nl: string = null;
    cci_dvcc_remarque_commande: string = null;
    cci_dvcc_remarque_commande_en: string = null;
    cci_dvcc_remarque_commande_de: string = null;
    cci_dvcc_remarque_commande_nl: string = null;
    cci_header_footer_color: string = null;                   
    cci_submenus_color: string = null;                        
    cci_nav_text_color: string = null;
    cci_date_echeance_facture_acte: number = 0; 
    cci_date_echeance_facture_tranche: number = 0;
    cci_date_echeance_facture_comission: number = 0;
    cci_date_echeance_facture_solde: number = 0;
    cci_date_echeance_facture_externe: number = 0;
    cci_ged_footers: string = null;
    cci_ndc_negatives: number = 0;
    cci_ajout_paiement: number = 0;
    cci_facturation_multilingue: number = 0;
    cci_gestion_plan_comptable: number = 0;
    cci_code_journal_exact: string = null;
    cci_coda: string = null;
    cci_min_deport_telechargement_facture: number = 0;
    cci_max_deport_telechargement_facture: number = 0;
    cci_forcer_date_jour_date_facture_comptabilisation: number = 1;
    cci_activation_optipol: number = 0;
    
    constructor(init = null) {
        if (init) {
            for (let prop in init) {
                if (prop !== 'cci_mode_a_17') {
                    switch (typeof this[prop]) {
                        case 'number':
                            this[prop] = init[prop] == null ? null : Number(init[prop]);
                            break;
                        case 'boolean':
                            this[prop] = init[prop] == '1';
                            break;
                        default:
                            this[prop] = init[prop] == null ? null : init[prop];   
                    }
                } else {
                    this.cci_mode_a_17 = init.cci_mode_a_17 === "promotion" ? Mode.PROMOTION : Mode.FACTURATION;
                }
            }
        }
    }
}
